import React from 'react';
import { useTranslation } from 'react-i18next';
import { REPORT_INPUT, REPORT_LABEL } from './ReportPageUi';

/**
 * حقول الهيكل التنظيمي المشتركة بين تقارير الإدارة.
 */
const ReportOrgFilterFields = ({
  filters,
  setFilters,
  lockedOrgLevels,
  countries,
  regions,
  academies,
  districts,
  institutions,
  departments,
  getCountryLabel
}) => {
  const { t } = useTranslation();

  const countryLabel = (c) => {
    if (getCountryLabel) return getCountryLabel(c);
    return c.translatedName || c.name || c.name_ar || c.name_fr || c.name_en;
  };

  return (
    <>
      <div>
        <label className={REPORT_LABEL}>{t('users.selectCountry')}</label>
        <select
          value={filters.countryId}
          onChange={(e) => setFilters((prev) => ({
            ...prev,
            countryId: e.target.value,
            regionId: '',
            academyId: '',
            districtId: '',
            institutionId: '',
            departmentId: ''
          }))}
          disabled={lockedOrgLevels.countryId}
          className={`${REPORT_INPUT} ${lockedOrgLevels.countryId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{t('users.selectCountry')}</option>
          {countries.map((c) => (
            <option key={c.id} value={c.id}>{countryLabel(c)}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={REPORT_LABEL}>{t('users.selectRegion')}</label>
        <select
          value={filters.regionId}
          onChange={(e) => setFilters((prev) => ({
            ...prev,
            regionId: e.target.value,
            academyId: '',
            districtId: '',
            institutionId: '',
            departmentId: ''
          }))}
          disabled={!filters.countryId || lockedOrgLevels.regionId}
          className={`${REPORT_INPUT} ${!filters.countryId || lockedOrgLevels.regionId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{!filters.countryId ? t('users.selectCountryFirst') : t('users.selectRegion')}</option>
          {regions.map((r) => (
            <option key={r.id} value={r.id}>{r.translatedName || r.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={REPORT_LABEL}>{t('users.selectAcademy')}</label>
        <select
          value={filters.academyId}
          onChange={(e) => setFilters((prev) => ({
            ...prev,
            academyId: e.target.value,
            districtId: '',
            institutionId: '',
            departmentId: ''
          }))}
          disabled={!filters.regionId || lockedOrgLevels.academyId}
          className={`${REPORT_INPUT} ${!filters.regionId || lockedOrgLevels.academyId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{!filters.regionId ? t('users.selectRegionFirst') : t('users.selectAcademy')}</option>
          {academies.map((a) => (
            <option key={a.id} value={a.id}>{a.translatedName || a.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={REPORT_LABEL}>{t('users.selectDistrict')}</label>
        <select
          value={filters.districtId}
          onChange={(e) => setFilters((prev) => ({
            ...prev,
            districtId: e.target.value,
            institutionId: '',
            departmentId: ''
          }))}
          disabled={!filters.academyId || lockedOrgLevels.districtId}
          className={`${REPORT_INPUT} ${!filters.academyId || lockedOrgLevels.districtId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{!filters.academyId ? t('users.selectAcademyFirst') : t('users.selectDistrict')}</option>
          {districts.map((d) => (
            <option key={d.id} value={d.id}>{d.translatedName || d.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('users.selectInstitution')}</label>
        <select
          value={filters.institutionId}
          onChange={(e) => setFilters((prev) => ({ ...prev, institutionId: e.target.value, departmentId: '' }))}
          disabled={!filters.districtId || lockedOrgLevels.institutionId}
          className={`${REPORT_INPUT} ${!filters.districtId || lockedOrgLevels.institutionId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{!filters.districtId ? t('users.selectDistrictFirst') : t('users.selectInstitution')}</option>
          {institutions.map((i) => (
            <option key={i.id} value={i.id}>{i.translatedName || i.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={REPORT_LABEL}>{t('users.selectDepartment')}</label>
        <select
          value={filters.departmentId || ''}
          onChange={(e) => setFilters((prev) => ({ ...prev, departmentId: e.target.value }))}
          disabled={!filters.institutionId || lockedOrgLevels.departmentId}
          className={`${REPORT_INPUT} ${!filters.institutionId || lockedOrgLevels.departmentId ? 'bg-slate-100 cursor-not-allowed opacity-90' : ''}`}
        >
          <option value="">{!filters.institutionId ? t('users.selectInstitutionFirst') : t('users.selectDepartment')}</option>
          {departments.map((d) => (
            <option key={d.id} value={String(d.id)}>{d.translatedName || d.name}</option>
          ))}
        </select>
      </div>
    </>
  );
};

export default ReportOrgFilterFields;
